export default {
apiKey: "AIzaSyCVBjdEvTXLN0ZD6Zf5gbsUbZiyrO7XfY8",
authDomain: "today-9d9e5.firebaseapp.com",
databaseURL: "https://today-9d9e5-default-rtdb.asia-southeast1.firebasedatabase.app",
projectId: "today-9d9e5",
storageBucket: "today-9d9e5.appspot.com",
messagingSenderId: "734948486724",
appId: "1:734948486724:web:ad87b09665265b26c7d611",
measurementId: "G-YL79GWH89N"
};